import React, { useMemo } from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { catchyTextFieldSx } from '../../theme/formStyles';
import { EntityOption } from './SearchableEntitySelect';

interface SearchableMultiEntitySelectProps {
  label: string;
  placeholder?: string;
  value: string[];
  options: EntityOption[];
  onChange: (ids: string[]) => void;
  required?: boolean;
}

export const SearchableMultiEntitySelect: React.FC<SearchableMultiEntitySelectProps> = ({
  label, placeholder, value, options, onChange, required,
}) => {
  const selected = useMemo(
    () => options.filter((o) => value.includes(o._id)),
    [options, value]
  );

  return (
    <Autocomplete
      multiple
      options={options}
      value={selected}
      onChange={(_e, opts) => onChange(opts.map((o) => o._id))}
      getOptionLabel={(opt) => opt.label}
      isOptionEqualToValue={(opt, val) => opt._id === val._id}
      filterOptions={(opts, { inputValue }) => {
        const q = inputValue.trim().toLowerCase();
        if (!q) return opts;
        return opts.filter((opt) =>
          [opt.label, opt.sublabel].filter(Boolean).some((text) => String(text).toLowerCase().includes(q))
        );
      }}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip {...getTagProps({ index })} key={option._id} label={option.label} size="small" />
        ))
      }
      renderOption={(props, option) => (
        <li {...props} key={option._id}>
          <div>
            <strong>{option.label}</strong>
            {option.sublabel && (
              <span style={{ display: 'block', fontSize: 12, opacity: 0.75 }}>{option.sublabel}</span>
            )}
          </div>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder || 'Search and select...'}
          required={required && !value.length}
          size="small"
          sx={catchyTextFieldSx}
        />
      )}
    />
  );
};
